import { z } from 'zod';
/**
 * 공고문에서 읽어낸 금액의 **성격**.
 *
 * 이 필드가 이 계약의 존재 이유다. 정규식 시절 `14,180억원`(부산시 융자 재원
 * 총액)이 어느 기업의 지원금으로 저장된 이유는, 총재원과 기업당 한도를
 * 형태로 구별할 수 없었기 때문이다. 둘 다 「지원」 근처의 「N억원」이다.
 *
 * 해석기는 숫자만 말하는 게 아니라 **그 숫자가 무엇인지** 말해야 한다.
 * `per_company_cap` 이 아니면 화면에 올리지 않는다.
 */
export const AMOUNT_KINDS = [
    /** 한 기업(신청자)이 받을 수 있는 상한. **이것만 지원금으로 취급한다.** */
    'per_company_cap',
    /** 사업·기금 전체 재원. 「융자 지원규모 3,300억원」 */
    'fund_total',
    /** 자격 요건. 「최근 3년 매출액 평균 200억원 이하」 */
    'eligibility',
    /** 계산 예시·FAQ. 「250억원의 50% = 125억원」 */
    'example',
    /**
     * 실비·견적 기준 전액 지원 — 상한이 숫자로 없다. 「견적서 2부(본 견적서·비교
     * 견적서)를 받아 낮은 견적 금액을 지원」. 실측 산청군 주방 위생환경개선
     * (f7442327): 숫자가 하나도 없지만 진짜 보조금이다. `maximumAmount` 는 비운다.
     */
    'actual_cost',
    /** 문서에 금액이 없다. 비율만 있거나 현물 지원이다. */
    'none',
];
/**
 * 해석기가 보내는 것.
 *
 * **금액을 숫자로만 받지 않는다.** 원문 문장을 그대로 인용하게 하고, 서버가
 * ① 그 문장이 원문에 문자 그대로 있는지 ② 그 문장에서 우리가 파싱한 숫자가
 * 보내온 값과 같은지를 대조한다. 어긋나면 거부한다. 환각한 자릿수가 DB 에
 * 들어갈 경로를 막는 것이 목적이다.
 */
export const amountAnalysisSchema = z.object({
    kind: z.enum(AMOUNT_KINDS),
    /**
     * 근거 문장. **원문에서 잘라낸 그대로여야 한다.** 다듬거나 요약하면 대조에
     * 실패해 거부된다 — 그게 의도다.
     */
    quote: z.string().min(1).max(500).nullable().default(null),
    /** 원 단위 정수. `kind` 가 per_company_cap 일 때만 의미가 있다. */
    amountMax: z.number().int().positive().nullable().default(null),
    /** 상한 없이 비율만 있을 때 (`총사업비의 50%`). */
    ratio: z.number().int().min(1).max(100).nullable().default(null),
    /** 어느 모델이 판정했는지. 나중에 모델을 바꿨을 때 비교하려면 남아야 한다. */
    model: z.string().min(1).max(120),
});
//# sourceMappingURL=grant-analysis.js.map